import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class InfoManyTexts extends DesigntimeComponent {
    static staticName = "Info (Many texts)";
    static staticId = "infoManyTexts";

    constructor(identifyer) {
        super(identifyer, 2);

        this.values = {};

        for (var i = 1; i < 10; i++) {
            this.values[`header${i}`] = new LiquidString(`Header ${i}`, `${this.id}_header${i}`);
            this.values[`text${i}`] = new LiquidString(`Text ${i}`, `${this.id}_text${i}`);
        }
        this.values.buttontext = { value: "Next" };
        this.values.imageurl = { value: "placeholder.png", dontTranslate: true };
        this.values.imageclass = { value: "sid-image-circle", dontTranslate: true };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 1 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        var $view = $("<div></div>");
        var $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append(this.values.header1.getTag("h3"));
        $textbox.append(this.values.text1.getTag("p"));
        $view.append($textbox);

        var $imagebox = $("<div class='sid-question-image'></div>");
        if (this.values.imageurl.value) {
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }

        return $view;
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        super.onRuntimeChanged(eventParams);

        if (eventParams.key == this.params.parameter1.key) {
            this.params.parameter1.value = eventParams.value;
            this.replaceParameter();
        }
    }

    replaceParameter() {
        if (this.params.parameter1.value == 0)
            return;

        let currentIndex = this.params.parameter1.value;

        var currentHeader = this.values["header" + currentIndex];
        var currentText = this.values["text" + currentIndex];

        var $header = componentHelpers.getRtFrame(this.id).find(`.sid-question-text`);
        $header.empty();
        $header.append(currentHeader.getTag("h3"));
        $header.append(currentText.getTag("p"));
    }
}

export { InfoManyTexts }

